import { Trans } from '@lingui/macro';
import { useEffect, useState } from 'react';
import { i18n } from '@lingui/core';
import { Link } from 'react-router-dom';

export const LanguageSelector = () => {
    const [isOpened, setIsOpened] = useState<boolean>(false);
    const toggle = () => {
        setIsOpened(!isOpened);
    }

    useEffect(() => {
        toggleOutsideClick();
    }, [])

    const toggleOutsideClick = () => {
        const element = document.querySelector('.language-switcher');
        document.addEventListener('mousedown', (event: any) => {
            if (!element?.contains(event.target) && event.target.tagName.toLowerCase() !== 'button') {
                setIsOpened(false);
            }
        })
    }

    return (
        <button language-switcher-toggle="" className={'px-4 position-relative hidden d-none d-lg-block ' + (isOpened ? 'active' : '')} onClick={() => toggle()}>
            <span className="sr-only">Toggle Language Switcher</span>
            <i className="pointer-events-none">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10.75 5C10.3125 2.21875 9.21875 0.25 8 0.25C6.75 0.25 5.6875 2.21875 5.21875 5H10.75ZM5 8C5 8.71875 5.03125 9.375 5.09375 10H10.875C10.9375 9.375 10.9688 8.71875 10.9688 8C10.9688 7.3125 10.9375 6.65625 10.875 6H5.09375C5.03125 6.65625 5 7.3125 5 8ZM15.125 5C14.25 2.90625 12.4375 1.25 10.1875 0.59375C10.9688 1.65625 11.4688 3.25 11.75 5H15.125ZM5.78125 0.59375C3.53125 1.25 1.71875 2.90625 0.84375 5H4.21875C4.5 3.25 5 1.65625 5.78125 0.59375ZM15.4688 6H11.875C11.9375 6.65625 12 7.34375 12 8C12 8.6875 11.9375 9.34375 11.875 10H15.4688C15.625 9.375 15.7188 8.71875 15.7188 8C15.7188 7.3125 15.625 6.65625 15.4688 6ZM4 8C4 7.34375 4.03125 6.65625 4.09375 6H0.5C0.34375 6.65625 0.25 7.3125 0.25 8C0.25 8.71875 0.34375 9.375 0.5 10H4.09375C4.03125 9.34375 4 8.6875 4 8ZM5.21875 11C5.6875 13.8125 6.75 15.75 8 15.75C9.21875 15.75 10.3125 13.8125 10.75 11H5.21875ZM10.1875 15.4375C12.4375 14.7812 14.25 13.125 15.125 11H11.75C11.5 12.7812 10.9688 14.375 10.1875 15.4375ZM0.84375 11C1.71875 13.125 3.53125 14.7812 5.78125 15.4375C5 14.375 4.5 12.7812 4.21875 11H0.84375Z"
                        fill="#131316"></path>
                </svg>
            </i>
            <div className="language-switcher">
                <div className="language-switcher-subheader">
                    <Trans>please choose your</Trans>
                </div>
                <div className="language-switcher-header text-purple">
                    <Trans>Language</Trans>
                </div>
                <ul className="links">
                    <li {...{ 'hrefLang': 'en' }} >
                        <Link reloadDocument to="/en" className={i18n.locale === 'en' ? 'is-active' : ''} hrefLang="en"><Trans>English</Trans></Link>
                    </li>
                    <li {...{ 'hrefLang': 'de' }}>
                        <Link reloadDocument to="/de" className={i18n.locale === 'de' ? 'is-active' : ''} hrefLang="de"><Trans>Deutsch</Trans></Link>
                    </li>
                </ul>
            </div>
        </button>
    );
}
